var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMeeting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 51.5,
    height: 51.5,
    rx: 25.75,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 51.5,
    height: 51.5,
    rx: 25.75,
    stroke: "#F03D3D",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5001 21.66C32.4401 21.65 32.3701 21.65 32.3101 21.66C30.9301 21.61 29.8301 20.48 29.8301 19.08C29.8301 17.65 30.9801 16.5 32.4101 16.5C33.8401 16.5 34.9901 17.66 34.9901 19.08C34.9801 20.48 33.8801 21.61 32.5001 21.66Z",
    stroke: "#F03D3D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4704 28.9402C32.8404 29.1702 34.3504 28.9302 35.4104 28.2202C36.8204 27.2802 36.8204 25.7402 35.4104 24.8002C34.3404 24.0902 32.8104 23.8502 31.4404 24.0902",
    stroke: "#F03D3D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4705 21.66C20.5305 21.65 20.6005 21.65 20.6605 21.66C22.0405 21.61 23.1405 20.48 23.1405 19.08C23.1405 17.65 21.9905 16.5 20.5605 16.5C19.1305 16.5 17.9805 17.66 17.9805 19.08C17.9905 20.48 19.0905 21.61 20.4705 21.66Z",
    stroke: "#F03D3D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5004 28.9402C20.1304 29.1702 18.6204 28.9302 17.5604 28.2202C16.1504 27.2802 16.1504 25.7402 17.5604 24.8002C18.6304 24.0902 20.1604 23.8502 21.5304 24.0902",
    stroke: "#F03D3D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5001 29.1297C26.4401 29.1197 26.3701 29.1197 26.3101 29.1297C24.9301 29.0797 23.8301 27.9497 23.8301 26.5497C23.8301 25.1197 24.9801 23.9697 26.4101 23.9697C27.8401 23.9697 28.9901 25.1297 28.9901 26.5497C28.9801 27.9497 27.8801 29.0897 26.5001 29.1297Z",
    stroke: "#F03D3D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5897 32.2794C22.1797 33.2194 22.1797 34.7594 23.5897 35.6994C25.1897 36.7694 27.8097 36.7694 29.4097 35.6994C30.8197 34.7594 30.8197 33.2194 29.4097 32.2794C27.8197 31.2194 25.1897 31.2194 23.5897 32.2794Z",
    stroke: "#F03D3D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMeeting);
export default __webpack_public_path__ + "static/media/iconMeeting.93e86a56e504a695b5344ff537424db4.svg";
export { ForwardRef as ReactComponent };